import { CardsStates } from "./enums/cardsStates";

/**  Данные по карте. */
export class CardData {
  /** Идентификатор в ДБО. */
  public Id: number = 0;

  public cardNumberColor: string = '';

  /** Состояние карты. */
  public CardState: CardsStates = 0;

  /** Алиас. */
  public Alias: string = "";

  /** ИД в Retail. */
  public ReferenceId: string = "";

  /** Наименование типа пластика. */
  public PlasticType: string = "";

  /** Номер. */
  public Number: string = "";

  /** Срок действия карты. */
  public ExpDate: string = "";

  /** Эмбоссированное имя. */
  public EmbossedName: string = "";

  /** Код изображения карты. */
  public CodeCardImage: string = "";

  /** Номер мобильного телефона для SMS-уведомлений. */
  public SmsPhone: string = "";

  /** Cостояние SMS-уведомления по номеру мобильного телефона. */
  public SmsStateCode: number = 0;

  /** Базовая процентная ставка кешбэка. */
  public CashbackRate: number = 0;

  /** BIN карты. */
  public BIN: string = "";

  public ViberService: string | null = null;

  public SmsService: string | null = null;

  public IsVirtualCard: boolean = false;

  /** Скрытая. */
  public Hidden: boolean = false;

  public TariffName: string = '';

  public TariffUrl: string = '';

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null) {
    if (src) {
      const sXml: string = src.CustomFields ?? "";

      // Парсим XML.
      const parser = new DOMParser();
      const xDoc = parser.parseFromString(sXml, "text/xml");

      const xmlFields = xDoc.getElementsByTagName('Field');

      this.Id = src.Id ?? 0;
      this.CardState = (src.State ?? 0) as CardsStates;
      this.Alias = src.Alias ?? "";
      this.ReferenceId = src.ReferenceId ?? "";
      this.PlasticType = src.PlasticType ?? "";
      this.Number = src.Number ?? "";
      this.ExpDate = src.ExpDate ?? "";
      this.EmbossedName = src.EmbossedName ?? "";
      this.CodeCardImage = src.CodeCardImage ?? "";
      this.SmsPhone = src.SmsPhone ?? "";
      this.SmsStateCode = src.SmsStateCode ?? "";
      this.CashbackRate = src.CashbackRate ?? 0;
      this.BIN = src.BIN ?? "";
      this.Hidden = src.Hidden ?? false;
      this.IsVirtualCard = src.IsVirtualCard ?? false;
      this.TariffName = src.TariffName ?? "";
      this.TariffUrl = src.TariffUrl ?? "";

      const CustomFields: Array<string> = ['SmsService', 'ViberService'];

      for(const j in CustomFields) {
        const key = CustomFields[j];
        for (let i = 0; i < xmlFields.length; i++) {
          const field = xmlFields[i];
          if (field.getAttribute('name') == key) {
            this[key] = field.getAttribute('value');
          }
        }
      }
    }
  }

  /**Обновить счет */
  public update(card: CardData): void {
    this.CardState = card.CardState;
    this.Alias = card.Alias;
  }
}
